import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import MultiCarousel from "react-multi-carousel";
import Parse from "html-react-parser";
import "react-multi-carousel/lib/styles.css";
import HfnImage from "../HfnImage";

function HfnCarousel(props) {
  const {
    Slide: items,
    maxSlides,
    swipeable,
    draggable,
    showDots,
    infinite,
    arrows,
    autoPlay,
    Title,
  } = props;

  const isZero = 0;

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: Number(maxSlides),
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  return (
    <MultiCarousel
      additionalTransfrom={0}
      arrows={arrows}
      autoPlay={autoPlay}
      autoPlaySpeed={4000}
      centerMode={false}
      className={`hfn_carousel_outer ${Title}`}
      containerClass="hfn_carousel_container"
      dotListClass="hfn_carousel_dots"
      draggable={draggable}
      focusOnSelect={false}
      infinite={infinite}
      itemClass="hfn_carousel_item"
      keyBoardControl
      pauseOnHover
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside
      renderDotsOutside={false}
      responsive={responsive}
      rewind={false}
      rewindWithAnimation={false}
      rtl={false}
      shouldResetAutoplay
      showDots={showDots}
      sliderClass="hfn_carousel_innner"
      slidesToSlide={1}
      swipeable={swipeable}
    >
      {items &&
        items?.length > isZero &&
        items?.map((item) => {
          if (!item?.Image) {
            return "";
          }
          return (
            <div key={item?.id}>
              <div className="hfn_slider_wrapper">
                <div className="hfn_slider_overlay_wrapper">
                  <HfnImage {...item?.Image} className="img-fluid" />
                </div>
                <div className="card-body">
                  {item?.Title && (
                    <div className="card-text card-content-wrapper">
                      {!item?.Link && item?.Title}
                      {item?.Link && (
                        <Link href={item?.Link} className="slide_link">
                          {item?.Title}
                        </Link>
                      )}
                    </div>
                  )}
                </div>
                <div className="card-description">
                  {item?.Description && (
                    <div className="card-text card-content-wrapper">
                      {Parse(item?.Description)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
    </MultiCarousel>
  );
}

// Specifies the default values for props:
HfnCarousel.defaultProps = {
  maxSlides: 4,
  swipeable: true,
  draggable: true,
  showDots: false,
  infinite: true,
  arrows: false,
  autoPlay: true,
};

HfnCarousel.propTypes = {
  /**
   * Title is wrapper for overall component
   * */
  Title: PropTypes.string.isRequired,
  /**
   * MaxSlides is a number for visible slide for a Desktop
   * */
  maxSlides: PropTypes.number,
  /**
   * Slides is actual list of data for component
   * */
  Slide: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      Title: PropTypes.string.isRequired,
      Link: PropTypes.string.isRequired,
      Description: PropTypes.string.isRequired,
      Image: PropTypes.shape({
        data: PropTypes.shape({
          attributes: PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            alternativeText: PropTypes.string.isRequired,
            height: PropTypes.number.isRequired,
            width: PropTypes.number.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    })
  ).isRequired,
  /**
   * Slider is swipeable or not- True | false
   * */
  swipeable: PropTypes.bool,
  /**
   * Slider is draggable or not - True | false
   * */
  draggable: PropTypes.bool,
  /**
   * Slider dots navigations are visible or not - True | false
   * */
  showDots: PropTypes.bool,
  /**
   * Slider is infinite scrollable or not - True | false
   * */
  infinite: PropTypes.bool,
  /**
   * Slider arrows navigations are visible or not - True | false
   * */
  arrows: PropTypes.bool,
  /**
   * Slider should autoplay or not - True | false
   * */
  autoPlay: PropTypes.bool,
};

export default HfnCarousel;
